import { Global } from '../state/Global';

const deviceManagementState = (state: Global, serialNumber: string) => {
  return state.app.get(`deviceManagement`).devices[serialNumber];
};

export {
  deviceManagementState
};
